import { gql } from '@apollo/client'

export const getOffersByIdQuery = gql`
  query getOffersById(
    $applicationInput: Credit_BusinessCredit_OfferConstraintsInput!
  ) {
    credit {
      businessCredit {
        offerConstraints(input: $applicationInput) {
          productOfferConstraints {
            maxTerm
            minTerm
            maxAmount {
              value
              currencyCode
            }
            minAmount {
              value
              currencyCode
            }
          }
          customOfferConstraints {
            maxProportionOfRevenue
            maxAmount {
              value
              currencyCode
            }
            term
            weeklyInterestRate
          }
        }
      }
    }
  }
`

export const getApplicationWithOfferByIdQuery = gql`
  query getApplicationById($applicationId: Credit_ApplicationID!) {
    credit {
      businessCredit {
        application(input: { id: $applicationId }) {
          id
          countryCode
          referenceId
          creditProductIdentifier
          originationUrl
          status
          statusReasons
          tags
          portalAccess {
            sessionId
            userToken
            url
            userId
          }
          evaluation {
            underwriting {
              offerConstraints {
                maxLoanAmount {
                  value
                  currencyCode
                }
              }
            }
          }
          business {
            legalBusinessName
            doingBusinessAsName
            formationDate
            formattedFormationDate {
              numericMonthDayShortYear
              numericMonthLongYear
            }
            incorporationRegion
            financialProfile {
              totalAnnualBusinessRevenue {
                currencyCode
                value
              }
              formattedTotalAnnualBusinessRevenue {
                amount
              }
              averageMonthlyGrossSales {
                value
                currencyCode
              }
            }
            numberOfFullTimeEmployees
            industryType
            subIndustryCode
            organizationType
            phones {
              countryCode
              nationalNumber
              extensionNumber
              type
              primary
            }
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
            websiteUrl
            loanHistory {
              wasPreviouslyFunded
              previousLoansPaidOff
              previousLoans {
                id
                outstandingPrincipalBalance {
                  value
                  currencyCode
                }
              }
              formattedTotalOutstandingPrincipalBalance {
                amount(
                  formatOptions: {
                    style: SYMBOL
                    minimumFractionDigits: 0
                    maximumFractionDigits: 0
                  }
                )
              }
            }
          }
          device {
            clientIpAddress
          }
          loanPurpose
          guarantor {
            emailAddress
            alternateEmailAddress
            businessAssociation {
              ownershipPercentage
              formattedOwnershipPercentage {
                percentage
              }
              roles
            }
            phones {
              countryCode
              nationalNumber
              extensionNumber
              type
              primary
            }
            name {
              givenName
              surname
            }
            address {
              countryCode
              addressLine1
              addressLine2
              addressLine3
              adminArea1
              adminArea2
              adminArea3
              adminArea4
              postalCode
            }
          }
          productDiscovery {
            source
            invitationCode
          }
          consents {
            type
            status
            recordedTime
          }
          campaign {
            id
          }
        }
      }
    }
  }
`
